export interface TickerItem {
  time: string;
  text: string;
}

export interface TrackingSideItem {
  tag: string;
  title: string;
  heat: string;
}

export interface FocusItem {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  image: string;
  heat: string;
  comments: number;
  updated: string;
}

export interface TimelineNode {
  date: string;
  time: string;
  title: string;
  desc: string;
  tone: 'neutral' | 'warn' | 'key';
}

export interface DerailRecord {
  rank: number;
  name: string;
  role: string;
  event: string;
  index: number;
  status: string;
  date: string;
}

export interface LatestItem {
  id: string;
  category: string;
  title: string;
  image: string;
  heat: string;
  time: string;
}

export interface HotComment {
  id: string;
  user: string;
  initial: string;
  tone: string;
  time: string;
  content: string;
  story: string;
  likes: number;
  replies: number;
}

export interface TrendTag {
  name: string;
  heat: string;
  trend: 'up' | 'down' | 'flat';
}

export const tickerItems: TickerItem[] = [
  { time: '12:40', text: '陆星辰工作室第三次改口，网友自发整理完整时间线' },
  { time: '12:18', text: '沈知远代言品牌方连夜下架全部合作物料' },
  { time: '11:52', text: '苏晚晴方回应网传消息：内容不实，已委托律师处理' },
  { time: '11:30', text: '江临巡演主办方宣布延期，退票通道今日开启' },
  { time: '10:55', text: '顾行舟新片路演临时取消，片方称「档期调整」' },
  { time: '10:20', text: '温念应援站集体闭站，三天内掉粉十二万' },
];

export const coverStory = {
  category: '丑闻曝光 · 追踪中',
  title: '陆星辰录音风波持续发酵：三方改口、五家品牌连夜切割',
  excerpt:
    '从凌晨爆料到午间第三份声明，事件在四十八小时内三次反转。本站梳理关键节点、当事方回应与商业去向，帮你一次看清整条脉络。',
  day: '第 6 天',
  heat: '982万',
  comments: 4126,
  updated: '12:40 更新',
  image:
    'https://readdy.ai/api/search-image?query=dramatic%20editorial%20magazine%20cover%20background%20with%20deep%20crimson%20red%20and%20charcoal%20black%20torn%20paper%20collage%20texture%2C%20cinematic%20hard%20lighting%2C%20high%20contrast%2C%20abstract%20artistic%20no%20text%2C%20grainy%20film%20photography%20feel&width=1600&height=1000&seq=cover-hero-18hl&orientation=landscape',
};

export const sideTrackings: TrackingSideItem[] = [
  { tag: '翻车记录', title: '沈知远代言全线撤下，违约金或被曝超千万', heat: '431万' },
  { tag: '黑料新进展', title: '苏晚晴律师函已送达，爆料账号清空历史内容', heat: '268万' },
  { tag: '爆料追踪', title: '江临巡演延期退票，主办方称「不可抗力」', heat: '205万' },
  { tag: '负面新闻', title: '韩斯年综艺剪辑争议升级，节目组深夜致歉', heat: '176万' },
];

export const focusItems: FocusItem[] = [
  {
    id: 'focus-gu',
    category: '负面新闻',
    title: '顾行舟新片庆功宴视频流出，片方否认「内定」传闻',
    excerpt: '疑似现场录音与多张饭拍同时出现，片方回应称系内部误会，暂不追责。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20empty%20cinema%20hall%20with%20crimson%20velvet%20seats%20and%20dim%20spotlight%2C%20cinematic%20editorial%20photography%2C%20dark%20dramatic%20contrast%2C%20muted%20warm%20tones&width=900&height=700&seq=focus-gu-01&orientation=landscape',
    heat: '312万',
    comments: 1860,
    updated: '09.12',
  },
  {
    id: 'focus-wen',
    category: '翻车记录',
    title: '温念应援站集体闭站：三天掉粉十二万，后援会停更',
    excerpt: '多个大粉账号同步切换为黑头像，粉丝群在凌晨被批量解散。',
    image:
      'https://readdy.ai/api/search-image?query=abandoned%20stage%20with%20single%20cold%20spotlight%20and%20scattered%20confetti%20on%20dark%20floor%2C%20moody%20editorial%20photography%2C%20deep%20shadow%2C%20muted%20amber%20accents&width=900&height=700&seq=focus-wen-02&orientation=landscape',
    heat: '264万',
    comments: 2140,
    updated: '09.11',
  },
  {
    id: 'focus-han',
    category: '丑闻曝光',
    title: '韩斯年综艺剪辑争议升级，节目组深夜发出致歉声明',
    excerpt: '争议片段被指断章取义，节目组已下架当期回放并承诺重剪。',
    image:
      'https://readdy.ai/api/search-image?query=television%20studio%20editing%20room%20with%20glowing%20monitors%20and%20empty%20chair%2C%20moody%20low%20key%20photography%2C%20warm%20amber%20screen%20glow%2C%20dark%20background&width=900&height=700&seq=focus-han-03&orientation=landscape',
    heat: '198万',
    comments: 1420,
    updated: '09.10',
  },
];

export const timelineNodes: TimelineNode[] = [
  {
    date: '09.07',
    time: '23:40',
    title: '匿名账号放出录音片段',
    desc: '话题两小时内冲上热搜第一，相关讨论量突破百万。',
    tone: 'key',
  },
  {
    date: '09.08',
    time: '08:10',
    title: '工作室首次回应',
    desc: '声明称「存在恶意剪辑」，但未给出完整时间线。',
    tone: 'warn',
  },
  {
    date: '09.08',
    time: '15:30',
    title: '合作品牌A暂停宣传',
    desc: '品牌方悄然撤下首页物料，未发任何公开声明。',
    tone: 'neutral',
  },
  {
    date: '09.09',
    time: '10:00',
    title: '工作室二次声明改口',
    desc: '措辞由「恶意剪辑」变为「存在误会」，被指前后矛盾。',
    tone: 'warn',
  },
  {
    date: '09.10',
    time: '21:15',
    title: '第三方放出完整音频',
    desc: '完整版时长与首发片段相差近四十分钟，评论区再度反转。',
    tone: 'key',
  },
  {
    date: '09.12',
    time: '12:40',
    title: '五家品牌陆续切割',
    desc: '截至发稿，工作室尚未就品牌动向作出回应。',
    tone: 'warn',
  },
];

export const derailRecords: DerailRecord[] = [
  { rank: 1, name: '沈知远', role: '演员', event: '代言物料连夜下架', index: 88, status: '品牌切割', date: '09.11' },
  { rank: 2, name: '温念', role: '偶像', event: '应援站集体闭站', index: 76, status: '粉丝流失', date: '09.10' },
  { rank: 3, name: '江临', role: '歌手', event: '巡演延期与退票', index: 71, status: '活动停摆', date: '09.12' },
  { rank: 4, name: '韩斯年', role: '综艺常驻', event: '剪辑争议致节目致歉', index: 64, status: '节目调整', date: '09.09' },
  { rank: 5, name: '白露', role: '模特', event: '旧照被翻出引发争议', index: 52, status: '澄清中', date: '09.08' },
];

export const latestItems: LatestItem[] = [
  {
    id: 'latest-1',
    category: '负面新闻',
    title: '程一帆被曝片场「耍大牌」，剧组回应称系沟通误会',
    image:
      'https://readdy.ai/api/search-image?query=empty%20film%20set%20with%20director%20chair%20and%20warm%20work%20lights%2C%20moody%20editorial%20photography%2C%20dusk%20tones%2C%20cinematic%20atmosphere&width=640&height=440&seq=latest-01&orientation=landscape',
    heat: '142万',
    time: '2 小时前',
  },
  {
    id: 'latest-2',
    category: '翻车记录',
    title: '林嘉树直播口误引发品牌方不满，相关回放已删除',
    image:
      'https://readdy.ai/api/search-image?query=dark%20broadcast%20microphone%20on%20empty%20desk%20with%20single%20warm%20key%20light%2C%20low%20key%20editorial%20photography%2C%20muted%20red%20background&width=640&height=440&seq=latest-02&orientation=landscape',
    heat: '118万',
    time: '4 小时前',
  },
  {
    id: 'latest-3',
    category: '黑料新进展',
    title: '苏晚晴律师函发出后，爆料人账号清空全部历史内容',
    image:
      'https://readdy.ai/api/search-image?query=stamped%20official%20document%20envelope%20on%20dark%20wooden%20desk%20with%20warm%20lamp%20light%2C%20editorial%20still%20life%2C%20moody%20tones&width=640&height=440&seq=latest-03&orientation=landscape',
    heat: '96万',
    time: '6 小时前',
  },
  {
    id: 'latest-4',
    category: '爆料追踪',
    title: '顾行舟庆功宴视频二次剪辑流出，画质来源遭质疑',
    image:
      'https://readdy.ai/api/search-image?query=blurred%20surveillance%20style%20corridor%20with%20flickering%20amber%20ceiling%20light%2C%20grainy%20editorial%20photography%2C%20dark%20suspenseful%20mood&width=640&height=440&seq=latest-04&orientation=landscape',
    heat: '86万',
    time: '8 小时前',
  },
  {
    id: 'latest-5',
    category: '负面新闻',
    title: '温念粉丝后援会完成换届，官方账号进入停更状态',
    image:
      'https://readdy.ai/api/search-image?query=stack%20of%20folded%20fan%20letters%20and%20pale%20luminous%20light%20sticks%20on%20dark%20surface%2C%20editorial%20still%20life%2C%20muted%20warm%20tones&width=640&height=440&seq=latest-05&orientation=landscape',
    heat: '74万',
    time: '10 小时前',
  },
  {
    id: 'latest-6',
    category: '黑料新进展',
    title: '江临合作单曲被音乐平台下架，官方未说明具体原因',
    image:
      'https://readdy.ai/api/search-image?query=orange%20studio%20headphones%20on%20empty%20mixing%20console%20with%20warm%20led%20indicators%2C%20moody%20editorial%20photography%2C%20dark%20ambient%20light&width=640&height=440&seq=latest-06&orientation=landscape',
    heat: '68万',
    time: '12 小时前',
  },
];

export const hotComments: HotComment[] = [
  {
    id: 'cm-1',
    user: '吃瓜第一线',
    initial: '吃',
    tone: 'primary',
    time: '12:36',
    content: '时间线整理得太清楚了，工作室三份声明前后对不上，评论区现在已经吵翻天。',
    story: '陆星辰录音风波',
    likes: 3280,
    replies: 412,
  },
  {
    id: 'cm-2',
    user: '冷静观察员',
    initial: '冷',
    tone: 'secondary',
    time: '12:20',
    content: '先别急着站队，等第三方完整音频和当事方书面回应出来再判断，去年那波反转还历历在目。',
    story: '陆星辰录音风波',
    likes: 2140,
    replies: 268,
  },
  {
    id: 'cm-3',
    user: '品牌方小透明',
    initial: '品',
    tone: 'accent',
    time: '11:58',
    content: '圈内朋友说物料下架速度这么快，基本就是内部已经定调了，剩下的只是时间问题。',
    story: '沈知远代言撤下',
    likes: 1560,
    replies: 190,
  },
  {
    id: 'cm-4',
    user: '脱粉回踩中',
    initial: '脱',
    tone: 'primary',
    time: '11:30',
    content: '应援站闭站那天晚上，群里一句话都没说，大家只是默默退了群，挺唏嘘的。',
    story: '温念应援站闭站',
    likes: 1320,
    replies: 305,
  },
];

export const trendTags: TrendTag[] = [
  { name: '陆星辰录音风波', heat: '982万', trend: 'up' },
  { name: '沈知远代言撤下', heat: '431万', trend: 'up' },
  { name: '苏晚晴律师函', heat: '268万', trend: 'down' },
  { name: '温念应援站闭站', heat: '205万', trend: 'up' },
  { name: '韩斯年剪辑争议', heat: '176万', trend: 'flat' },
  { name: '江临巡演延期', heat: '154万', trend: 'down' },
  { name: '白露旧照争议', heat: '98万', trend: 'flat' },
  { name: '顾行舟庆功宴视频', heat: '86万', trend: 'up' },
];

export const topicCloud: string[] = [
  '人设崩塌',
  '品牌切割',
  '律师函',
  '深夜道歉',
  '剪辑争议',
  '粉丝脱粉',
  '活动延期',
  '物料下架',
  '代言解约',
  '时间线反转',
];

export const navLinks = [
  { label: '首页', active: true },
  { label: '负面新闻', active: false },
  { label: '丑闻曝光', active: false },
  { label: '翻车记录', active: false },
  { label: '黑料新进展', active: false },
  { label: '爆料追踪', active: false },
];